import { registerInteraction, type InteractionComponent } from './registry'
import { MultipleChoice } from './MultipleChoice'
import { Reveal } from './Reveal'
import { ShortResponse } from './ShortResponse'
import { SortItems } from './SortItems'
import { BankBalanceSheetLab } from './BankBalanceSheetLab'
import { LiquidityCrisisLab } from './LiquidityCrisisLab'

/**
 * Registers the reusable and custom interaction components. Called once before
 * any lesson renders. Idempotent.
 */

const CORE_INTERACTIONS: Record<string, InteractionComponent> = {
  'multiple-choice': MultipleChoice,
  reveal: Reveal,
  'short-response': ShortResponse,
  'sort-items': SortItems,
  'bank-balance-sheet-lab': BankBalanceSheetLab,
  'liquidity-crisis-lab': LiquidityCrisisLab,
}

let registered = false

/** Register the interactions. Idempotent. */
export function registerDefaultInteractions(): void {
  if (registered) return
  for (const [name, component] of Object.entries(CORE_INTERACTIONS)) {
    registerInteraction(name, component)
  }
  registered = true
}
